module.exports = __webpack_public_path__ + "img/1503272123.f9d6beb8.jpg";